import React from 'react';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { AccountSMTPSettings } from './types';
import { InputWrapper } from './styles';

type Props = {
  visible: boolean;
  onClose: () => void | Promise<void>;
  loading: boolean;
  smtp: AccountSMTPSettings;
  setSmtp: (updater: any) => void;
  onVerify: () => void | Promise<void>;
};

const SmtpDialog: React.FC<Props> = ({ visible, onClose, loading, smtp, setSmtp, onVerify }) => (
  <DialogComponent
    visible={visible}
    width="420px"
    isModal
    showCloseIcon
    header="SMTP Zugangsdaten"
    close={onClose}
    buttons={[
      {
        buttonModel: { content: loading ? 'Verifiziere...' : 'Verifizieren', isPrimary: true, cssClass: 'e-custom modal-dialog-btn' },
        click: onVerify,
      },
    ]}
  >
    <div style={{ padding: 16 }}>
      <InputWrapper>
        <TextBoxComponent 
          value={smtp.host} 
          floatLabelType="Auto" 
          placeholder="SMTP Host" 
          input={(e: any) => setSmtp({ ...smtp, host: e.value })} 
        />
      </InputWrapper>

      <InputWrapper>
        <TextBoxComponent 
          value={String(smtp.port)} 
          floatLabelType="Auto" 
          placeholder="SMTP Port" 
          input={(e: any) => setSmtp({ ...smtp, port: parseInt(e.value, 10) })} 
        />
      </InputWrapper>

      <InputWrapper>
        <DropDownListComponent 
          dataSource={['ssl', 'tls', 'starttls', 'none']} 
          value={smtp.secure} 
          change={(e: any) => setSmtp({ ...smtp, secure: e.value })} 
        />
      </InputWrapper>

      <InputWrapper>
        <DropDownListComponent 
          dataSource={['password', 'oauth2']} 
          value={smtp.auth_method} 
          change={(e: any) => setSmtp({ ...smtp, auth_method: e.value })} 
        />
      </InputWrapper>

      <InputWrapper>
        <TextBoxComponent 
          value={smtp.username} 
          floatLabelType="Auto" 
          placeholder="SMTP Benutzername" 
          input={(e: any) => setSmtp({ ...smtp, username: e.value })} 
        />
      </InputWrapper>

      <InputWrapper>
        <TextBoxComponent 
          type="password" 
          value={smtp.password || ''} 
          floatLabelType="Auto" 
          placeholder="SMTP Passwort" 
          input={(e: any) => setSmtp({ ...smtp, password: e.value })} 
        />
      </InputWrapper>

      <InputWrapper>
        <DropDownListComponent 
          dataSource={['true', 'false']} 
          value={smtp.require_tls} 
          change={(e: any) => setSmtp({ ...smtp, require_tls: e.value })} 
        />
      </InputWrapper>
    </div>
  </DialogComponent>
);

export default SmtpDialog;
